window.addEventListener('load', function () {
  setTimeout(function () {
    const wingOptions = [];

    // Loop over swatch elements related to Wings
    document.querySelectorAll('.pplr-swatch-element.pplrimage[name="properties[Wings]"]').forEach(function (el) {

      // Make the .img_dropdown visible
      const dropdown = el.querySelector('.img_dropdown');
      if (dropdown) {
        dropdown.style.display = 'block'; // Or '' depending on how visibility is being overridden
      }
      
      const tooltip = el.querySelector('.swtooltip');
      if (tooltip) {
        tooltip.remove(); // Or '' depending on how visibility is being overridden
      }

    });
      document.querySelectorAll('.pplr-swatch-element.pplrimage[name="properties[Wing Colors]"]').forEach(function (ef) {
       // Make the .img_dropdown visible
      const wingColorsdropdown = ef.querySelector('.img_dropdown');
      if (wingColorsdropdown) {
        wingColorsdropdown.style.display = 'block'; // Or '' depending on how visibility is being overridden
      }
         const tooltip = ef.querySelector('.swtooltip');
      if (tooltip) {
        tooltip.remove(); // Or '' depending on how visibility is being overridden
      }
    });

     document.querySelectorAll('.pplr-swatch-element.pplrimage[name="properties[Wing Color]"]').forEach(function (eg) {
       // Make the .img_dropdown visible
      const wingColordropdown = eg.querySelector('.img_dropdown');
      if (wingColordropdown) {
        wingColordropdown.style.display = 'block'; // Or '' depending on how visibility is being overridden
      }
       const tooltip = eg.querySelector('.swtooltip');
      if (tooltip) {
        tooltip.remove(); // Or '' depending on how visibility is being overridden
      }
       
    });
     document.querySelectorAll('.pplr-swatch-element.pplrimage[name="properties[Border]"]').forEach(function (eh) {
       // Make the .img_dropdown visible
      const borderdropdown = eh.querySelector('.img_dropdown');
      if (borderdropdown) {
        borderdropdown.style.display = 'block'; // Or '' depending on how visibility is being overridden
      }
       const tooltip = eh.querySelector('.swtooltip');
      if (tooltip) {
        tooltip.remove(); // Or '' depending on how visibility is being overridden
      }
    });

     document.querySelectorAll('.pplr-swatch-element.pplrimage[name="properties[Special Background 1]"]').forEach(function (ei) {
       // Make the .img_dropdown visible
      const background1dropdown = ei.querySelector('.img_dropdown');
      if (background1dropdown) {
        background1dropdown.style.display = 'block'; // Or '' depending on how visibility is being overridden
      }
       const tooltip = ei.querySelector('.swtooltip');
      if (tooltip) {
        tooltip.remove(); // Or '' depending on how visibility is being overridden
      }
    });
    document.querySelectorAll('.pplr-swatch-element.pplrimage[name="properties[ Special Background 2]"]').forEach(function (ej) {
       // Make the .img_dropdown visible

      const background2dropdown = ej.querySelector('.img_dropdown');
      if (background2dropdown) {
        background2dropdown.style.display = 'block'; // Or '' depending on how visibility is being overridden
      }
      const tooltip = ej.querySelector('.swtooltip');
      if (tooltip) {
        tooltip.remove(); // Or '' depending on how visibility is being overridden
      }
    });
    console.log("Wings found:", wingOptions);
  }, 500);
});